<script>
import { h } from 'vue';

export default {
  name: 'cContainer',
  data() {
    return {};
  },
  props: {},
  computed: {},
  methods: {},
  render() {
    return h(
      'div',
      {
        class: { 'c-container': true }
      },
      [
        this.$slots.title && this.$slots.title(),
        h(
          'div',
          {
            class: { 'c-container-contents': true }
          },
          [this.$slots.contents && this.$slots.contents()]
        )
      ]
    );
  }
};
</script>
<style lang="scss" scoped>
.c-container {
  padding: 8px 40px;

  &-contents {
    padding: 20px 32px;
    min-height: 300px;

    &__btngroup {
      text-align: right;
      margin-bottom: 12px;
    }
  }
}
</style>
